import React from "react";
import "./section4.css";
import { MdMovieFilter } from "react-icons/md";
import { GoFileCode } from "react-icons/go";
import { FaAdobe } from "react-icons/fa";
import { isMobile } from "react-device-detect";

export default function Section4() {
  return (
    <section className="page-section section4 container-fluid">
      <div className="container">
        <div className="row py-md-0 py-5">
          <div className="col-12">
            <div className="section-header">
              <h1 className="font-weight-bold mb-0 display-4">
                What Makes Me Different?
              </h1>
              <div data-aos="fade-right" className="underline w-25"></div>
            </div>
          </div>
          <div className="col-12 mt-md-5 mt-3">
            <div className="row px-2">
              <div
                data-aos="fade-up"
                data-aos-duration="600"
                className="col-lg col-md-6 col-12 px-md-3 px-0 "
              >
                <div className=" work-container p-4  h-100">
                  <div className="work-icon-container d-flex justify-content-center align-items-center">
                    <MdMovieFilter color="#EA3960" size="2.5em" />
                  </div>
                  <h4 className="weight-700 mt-4 pt-2">Motion Graphics</h4>
                  <p className="description">
                    Design extends far beyond screens and pages. And I focus on
                    brand building with graphic designs that is tailored to your
                    unique business needs.
                  </p>
                </div>
              </div>
              <div
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay={isMobile ? "100" : "200"}
                className="col-lg col-md-6 col-12 px-md-3 px-0 mt-md-0 mt-4"
              >
                <div className=" work-container p-4 ">
                  <div className="work-icon-container d-flex justify-content-center align-items-center">
                    <GoFileCode color="#EA3960" size="2.5em" />
                  </div>
                  <h4 className="weight-700 mt-4 pt-2">Development</h4>
                  <p className="description">
                    Specialized in crafting your website and mobile app layout
                    that suits your business needs making it aesthetically
                    appealing, but also make sure it is robust when it comes to
                    performance as well.
                  </p>
                </div>
              </div>
              <div
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay={isMobile ? "150" : "400"}
                className="col-lg col-md-12 col-12 px-md-3 px-0 mt-lg-0 mt-4"
              >
                <div className=" work-container p-4 h-100">
                  <div className="work-icon-container d-flex justify-content-center align-items-center">
                    <FaAdobe color="#EA3960" size="2.5em" />
                  </div>
                  <h4 className="weight-700 mt-4 pt-2">Branding</h4>
                  <p className="description">
                    Crafting a brand identity for your business that will convey
                    your intension, goals and all that you intend to do for your
                    audience - embedded inside a single design
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
